import * as React from "react";
import LutelyLogoImage from "@/components/icons/lib/lutely-logo";

function LutelyLogoMobile() {
  return <LutelyLogoImage width={85} height={22}/>;
}

const LutelyLogoMobileIcon = React.memo(LutelyLogoMobile);
export default LutelyLogoMobileIcon;
